import { required, integer, minValue, requiredIf, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      cancellation_reason_id: {
        required: helpers.withMessage(i18n.global.t('Please select a cancellation reason.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
      },
      cancel_quantity: {
        required: helpers.withMessage(i18n.global.t('Quantity is required.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be at least 1.'), minValue(1)),
      },
      is_restock: {
        required: helpers.withMessage(
          i18n.global.t('Please specify whether to restock.'),
          (val) => val === true || val === false
        ),
      },
      restock_quantity: {
        requiredIfRestock: helpers.withMessage(
          i18n.global.t('Please enter restock quantity.'),
          requiredIf(() => formState.is_restock === true)
        ),
        minValue: helpers.withMessage(
          i18n.global.t('Restock quantity must be at least 1.'),
          (val) => !formState.is_restock || (val !== null && val !== '' && Number(val) >= 1)
        ),
        lteCancel: helpers.withMessage(
          i18n.global.t('Restock quantity cannot exceed cancel quantity.'),
          (val) => !formState.is_restock || (val !== null && val !== '' && Number(val) <= Number(formState.cancel_quantity || 0))
        ),
      },
    }
  }
};
